import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {

  @Input() localeId: string;
  @Input() logoName: string;

  constructor(
    private _navigationService: NavigationService
  ) {
  }

  ngOnInit() {
  }

  goToHomeLocale() {
    this._navigationService.goToHomeLocale(this.localeId);
  }

  get src(): string {
    return this.logoName ? `assets/${this.localeId}/${this.logoName}` : `assets/${this.localeId}/logo.png`;
  }

}
